import axios from 'axios'
import * as types from '../types'

const state = {
  accountData: null,
  deliveryDetailsBusy: false,
  deliveryDetailsStatus: null,
  invoiceDetailsStatus: null,
  invoiceDetailsBusy: null,
  loginDetailsStatus: null,
  loginDetailsBusy: null,
  passwordDetailsStatus: null,
  passwordDetailsBusy: null,
  openingHoursDetailsStatus: null,
  openingHoursDetailsBusy: null,
  personalDetailsStatus: null,
  personalDetailsBusy: null,
  companyDetailsStatus: null,
  companyDetailsBusy: null,
  unloadingDetailsStatus: null,
  unloadingDetailsBusy: null
}

const getters = {
  accountData: (state) => {
    return state.accountData
  },
  deliveryDetailsStatus: (state) => {
    return state.deliveryDetailsStatus
  },
  deliveryDetailsBusy: (state) => {
    return state.deliveryDetailsBusy
  },
  invoiceDetailsStatus: (state) => {
    return state.invoiceDetailsStatus
  },
  invoiceDetailsBusy: (state) => {
    return state.invoiceDetailsBusy
  },
  loginDetailsStatus: (state) => {
    return state.loginDetailsStatus
  },
  loginDetailsBusy: (state) => {
    return state.loginDetailsBusy
  },
  passwordDetailsStatus: (state) => {
    return state.passwordDetailsStatus
  },
  passwordDetailsBusy: (state) => {
    return state.passwordDetailsBusy
  },
  openingHoursDetailsStatus: (state) => {
    return state.openingHoursDetailsStatus
  },
  openingHoursDetailsBusy: (state) => {
    return state.openingHoursDetailsBusy
  },
  personalDetailsStatus: (state) => {
    return state.personalDetailsStatus
  },
  personalDetailsBusy: (state) => {
    return state.personalDetailsBusy
  },
  companyDetailsStatus: (state) => {
    return state.companyDetailsStatus
  },
  companyDetailsBusy: (state) => {
    return state.companyDetailsBusy
  },
  unloadingDetailsStatus: (state) => {
    return state.unloadingDetailsStatus
  },
  unloadingDetailsBusy: (state) => {
    return state.unloadingDetailsBusy
  }
}

const mutations = {
  [types.MUTATE_ACCOUNT_DATA]: (state, accountData) => {
    state.accountData = accountData
  },
  [types.MUTATE_DELIVERY_DETAILS_STATUS]: (state, deliveryDetailsStatusData) => {
    state.deliveryDetailsStatus = deliveryDetailsStatusData
  },
  [types.MUTATE_DELIVERY_DETAILS_BUSY]: (state, deliveryDetailsBusyData) => {
    state.deliveryDetailsBusy = deliveryDetailsBusyData
  },
  [types.MUTATE_INVOICE_DETAILS_STATUS]: (state, invoiceDetailsStatusData) => {
    state.invoiceDetailsStatus = invoiceDetailsStatusData
  },
  [types.MUTATE_INVOICE_DETAILS_BUSY]: (state, invoiceDetailsBusyData) => {
    state.invoiceDetailsBusy = invoiceDetailsBusyData
  },
  [types.MUTATE_LOGIN_DETAILS_STATUS]: (state, loginDetailsStatusData) => {
    state.loginDetailsStatus = loginDetailsStatusData
  },
  [types.MUTATE_LOGIN_DETAILS_BUSY]: (state, loginDetailsBusyData) => {
    state.loginDetailsBusy = loginDetailsBusyData
  },
  [types.MUTATE_PASSWORD_DETAILS_STATUS]: (state, passwordDetailsStatusData) => {
    state.passwordDetailsStatus = passwordDetailsStatusData
  },
  [types.MUTATE_PASSWORD_DETAILS_BUSY]: (state, passwordDetailsBusyData) => {
    state.passwordDetailsBusy = passwordDetailsBusyData
  },
  [types.MUTATE_OPENING_HOURS_DETAILS_STATUS]: (state, openingHoursDetailsStatusData) => {
    state.openingHoursDetailsStatus = openingHoursDetailsStatusData
  },
  [types.MUTATE_OPENING_HOURS_DETAILS_BUSY]: (state, openingHoursDetailsBusyData) => {
    state.openingHoursDetailsBusy = openingHoursDetailsBusyData
  },
  [types.MUTATE_PERSONAL_DETAILS_STATUS]: (state, personalDetailsStatusData) => {
    state.personalDetailsStatus = personalDetailsStatusData
  },
  [types.MUTATE_PERSONAL_DETAILS_BUSY]: (state, personalDetailsBusyData) => {
    state.personalDetailsBusy = personalDetailsBusyData
  },
  [types.MUTATE_COMPANY_DETAILS_STATUS]: (state, companyDetailsStatusData) => {
    state.companyDetailsStatus = companyDetailsStatusData
  },
  [types.MUTATE_COMPANY_DETAILS_BUSY]: (state, companyDetailsBusyData) => {
    state.companyDetailsBusy = companyDetailsBusyData
  },
  [types.MUTATE_UNLOADING_DETAILS_STATUS]: (state, unloadingDetailsStatusData) => {
    state.unloadingDetailsStatus = unloadingDetailsStatusData
  },
  [types.MUTATE_UNLOADING_DETAILS_BUSY]: (state, unloadingDetailsBusyData) => {
    state.unloadingDetailsBusy = unloadingDetailsBusyData
  }
}

const actions = {
  [types.FETCH_ACCOUNT_DATA]: ({ commit }) => {
    axios
      .get('/account/data')
      .then(res => {
        // Commit our data
        commit(types.MUTATE_ACCOUNT_DATA, res.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  [types.SAVE_DELIVERY_DETAILS]: ({ commit, state, dispatch }, deliveryDetails) => {
    // First empty the status
    commit(types.MUTATE_DELIVERY_DETAILS_STATUS, null)
    commit(types.MUTATE_DELIVERY_DETAILS_BUSY, true)
    return axios
      .post('/account/delivery-address-details', deliveryDetails)
      .then(res => {
        commit(types.MUTATE_DELIVERY_DETAILS_STATUS, {
          'message': res.data.message,
          'success': true
        })
        // We should also refetch the account data to update the frontend
        dispatch(types.FETCH_ACCOUNT_DATA)
      })
      .catch(error => {
        commit(types.MUTATE_DELIVERY_DETAILS_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_DELIVERY_DETAILS_BUSY, false)
      })
  },
  [types.SAVE_INVOICE_DETAILS]: ({ commit, state, dispatch }, invoiceDetails) => {
    // First empty the status
    commit(types.MUTATE_INVOICE_DETAILS_STATUS, null)
    commit(types.MUTATE_INVOICE_DETAILS_BUSY, true)
    return axios
      .post('/account/invoice-address-details', invoiceDetails)
      .then(res => {
        commit(types.MUTATE_INVOICE_DETAILS_STATUS, {
          'message': res.data.message,
          'success': true
        })
        // We should also refetch the account data to update the frontend
        dispatch(types.FETCH_ACCOUNT_DATA)
      })
      .catch(error => {
        commit(types.MUTATE_INVOICE_DETAILS_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_INVOICE_DETAILS_BUSY, false)
      })
  },
  [types.SAVE_LOGIN_DETAILS]: ({ commit, state, dispatch }, loginDetails) => {
    // First empty the status
    commit(types.MUTATE_LOGIN_DETAILS_STATUS, null)
    commit(types.MUTATE_LOGIN_DETAILS_BUSY, true)
    return axios
      .post('/account/login-details', loginDetails)
      .then(res => {
        commit(types.MUTATE_LOGIN_DETAILS_STATUS, {
          'message': res.data.message,
          'success': true
        })
        // We should also refetch the account data to update the frontend
        dispatch(types.FETCH_ACCOUNT_DATA)
      })
      .catch(error => {
        commit(types.MUTATE_LOGIN_DETAILS_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_LOGIN_DETAILS_BUSY, false)
      })
  },
  [types.SAVE_PASSWORD_DETAILS]: ({ commit, state, dispatch }, passwordDetails) => {
    // First empty the status
    commit(types.MUTATE_PASSWORD_DETAILS_STATUS, null)
    commit(types.MUTATE_PASSWORD_DETAILS_BUSY, true)
    return axios
      .post('/account/password-details', passwordDetails)
      .then(res => {
        commit(types.MUTATE_PASSWORD_DETAILS_STATUS, {
          'message': res.data.message,
          'success': true
        })
      })
      .catch(error => {
        commit(types.MUTATE_PASSWORD_DETAILS_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_PASSWORD_DETAILS_BUSY, false)
      })
  },
  [types.SAVE_OPENING_HOURS_DETAILS]: ({ commit, state, dispatch }, openingHoursDetails) => {
    // First empty the status
    commit(types.MUTATE_OPENING_HOURS_DETAILS_STATUS, null)
    commit(types.MUTATE_OPENING_HOURS_DETAILS_BUSY, true)
    return axios
      .post('/account/opening-hours-details', openingHoursDetails)
      .then(res => {
        commit(types.MUTATE_OPENING_HOURS_DETAILS_STATUS, {
          'message': res.data.message,
          'success': true
        })
        // We should also refetch the account data to update the frontend
        dispatch(types.FETCH_ACCOUNT_DATA)
      })
      .catch(error => {
        commit(types.MUTATE_OPENING_HOURS_DETAILS_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_OPENING_HOURS_DETAILS_BUSY, false)
      })
  },
  [types.SAVE_PERSONAL_DETAILS]: ({ commit, state, dispatch }, personalDetails) => {
    // First empty the status
    commit(types.MUTATE_PERSONAL_DETAILS_STATUS, null)
    commit(types.MUTATE_PERSONAL_DETAILS_BUSY, true)
    return axios
      .post('/account/personal-details', personalDetails)
      .then(res => {
        commit(types.MUTATE_PERSONAL_DETAILS_STATUS, {
          'message': res.data.message,
          'success': true
        })
        // We should also refetch the account data to update the frontend
        dispatch(types.FETCH_ACCOUNT_DATA)
      })
      .catch(error => {
        commit(types.MUTATE_PERSONAL_DETAILS_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_PERSONAL_DETAILS_BUSY, false)
      })
  },
  [types.SAVE_COMPANY_DETAILS]: ({ commit, state, dispatch }, companyDetails) => {
    // First empty the status
    commit(types.MUTATE_COMPANY_DETAILS_STATUS, null)
    commit(types.MUTATE_COMPANY_DETAILS_BUSY, true)
    return axios
      .post('/account/company-details', companyDetails)
      .then(res => {
        commit(types.MUTATE_COMPANY_DETAILS_STATUS, {
          'message': res.data.message,
          'success': true
        })
        // We should also refetch the account data to update the frontend
        dispatch(types.FETCH_ACCOUNT_DATA)
      })
      .catch(error => {
        commit(types.MUTATE_COMPANY_DETAILS_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_COMPANY_DETAILS_BUSY, false)
      })
  },
  [types.SAVE_UNLOADING_DETAILS]: ({ commit, state, dispatch }, unloadingDetails) => {
    // First empty the status
    commit(types.MUTATE_UNLOADING_DETAILS_STATUS, null)
    commit(types.MUTATE_UNLOADING_DETAILS_BUSY, true)
    return axios
      .post('/account/unloading-method-details', unloadingDetails)
      .then(res => {
        commit(types.MUTATE_UNLOADING_DETAILS_STATUS, {
          'message': res.data.message,
          'success': true
        })
        // We should also refetch the account data to update the frontend
        dispatch(types.FETCH_ACCOUNT_DATA)
      })
      .catch(error => {
        commit(types.MUTATE_UNLOADING_DETAILS_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_UNLOADING_DETAILS_BUSY, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
